<template>
  <div>
    <!-- Light Mode Section -->
    <section>

        <div class="horizontal-scroll-container">
          <div class="horizontal-scroll-content">
            <img
                v-for="(image, index) in lightModeImages"
                :key="'light-' + index"
                :src="image.thumbnail"
                :alt="image.alt"
                @click="openModal(image)"
                class="screen-cap-th"
            >
          </div>
        </div>

    </section>

    <!-- Dark Mode Section -->
<!--
    <section>
      <div class="horizontal-scroll-container">
        <div class="horizontal-scroll-content">
          <img
              v-for="(image, index) in darkModeImages"
              :key="'light-' + index"
              :src="image.thumbnail"
              :alt="image.alt"
              @click="openModal(image)"
              class="screen-cap-th"
          >
        </div>
      </div>


    </section>
-->

    <!-- Modal -->
    <Teleport to="body">
      <div v-if="selectedImage"
           @click="closeModal"
           style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.9); overflow-y: auto; display: flex; align-items: center; justify-content: center;">
        <div style="width: 90vw; height: 90vh; position: relative;">
          <img :src="selectedImage.full"
               style="width: 100%; height: 100%; object-fit: contain;">
        </div>
      </div>

    </Teleport>

  </div>
</template>

<script setup>

import {ref} from 'vue'

const lightModeImages = ref([
  {
    thumbnail: '/images/screen_caps/app_store/01.png',
    full: '/images/screen_caps/app_store/01.png',
    alt: 'Light mode screen 1'
  },
  {
    thumbnail: '/images/screen_caps/app_store/02.png',
    full: '/images/screen_caps/app_store/02.png',
    alt: 'Light mode screen 2'
  },
  {
    thumbnail: '/images/screen_caps/app_store/03.png',
    full: '/images/screen_caps/app_store/03.png',
    alt: 'Light mode screen 3'
  },
  {
    thumbnail: '/images/screen_caps/app_store/04.png',
    full: '/images/screen_caps/app_store/04.png',
    alt: 'Light mode screen 4'
  },
  {
    thumbnail: '/images/screen_caps/app_store/05.png',
    full: '/images/screen_caps/app_store/05.png',
    alt: 'Light mode screen 5'
  },
  // Add more light mode images
])

// const darkModeImages = ref([
//   {
//     thumbnail: '/images/screen_caps/darkmode/000.1.png',
//     full: '/images/screen_caps/darkmode/000.1.png',
//     alt: 'Dark mode screen 1'
//   },
//   {
//     thumbnail: '/images/screen_caps/darkmode/001.1.png',
//     full: '/images/screen_caps/darkmode/001.1.png',
//     alt: 'Dark mode screen 1'
//   },
//   {
//     thumbnail: '/images/screen_caps/darkmode/002.1.png',
//     full: '/images/screen_caps/darkmode/002.1.png',
//     alt: 'Dark mode screen 1'
//   },
//   {
//     thumbnail: '/images/screen_caps/darkmode/003.1.png',
//     full: '/images/screen_caps/darkmode/003.1.png',
//     alt: 'Dark mode screen 1'
//   },
//   {
//     thumbnail: '/images/screen_caps/darkmode/004.1.png',
//     full: '/images/screen_caps/darkmode/004.1.png',
//     alt: 'Dark mode screen 1'
//   },
//   // Add more dark mode images
// ])

const selectedImage = ref(null)

const openModal = (image) => {
  console.log('Modal opened:', image)
  selectedImage.value = image
  document.body.style.overflow = 'hidden'
}

const closeModal = () => {
  selectedImage.value = null
  document.body.style.overflow = ''
}
</script>

<style scoped>

.horizontal-scroll-container {
  width: 100%;
  overflow-x: auto;
  white-space: nowrap;
  display: flex;
  justify-content: flex-start;
  /*background-color: lightblue;*/
  padding: 8px 0 8px 0;
}

.horizontal-scroll-content {
  display: flex;
  gap: 10px;
  width: max-content;
  /*background-color: lightcoral;*/
}

.screen-cap-th {
  height: auto;
  max-height: 250px;
  width: auto;
  max-width: 100%;
  border-radius: 10px;
  flex-shrink: 0; /* Prevents images from squishing */
}

</style>